import { CommonModule } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { BootstrapComponent } from '@core/components/bootstrap/bootstrap.component';
import { AuthorizationInterceptor } from '@core/interceptors/authorization.interceptor';

import { TranslateModule } from '@ngx-translate/core';

import {
  ApiHeadersInterceptor,
  ApiPrefixInterceptor,
  CustomParamInterceptor,
  ErrorHandlerInterceptor,
  HttpTokenInterceptor,
} from './interceptors';

@NgModule({
  imports: [CommonModule, TranslateModule, BootstrapComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiHeadersInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiPrefixInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomParamInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    // Import guard
    if (parentModule) {
      throw new Error(
        `${parentModule.constructor.name} has already been loaded. Import Core module in the AppModule only.`
      );
    }
  }
}
